
import CarriersHoraire from '@/pages/cart/components/CarriersHoraire.vue';
import SlideDownUp from '@/components/transitions/SlideDownUp.vue';
import { ChevronDownIcon } from 'vue-feather-icons';
import { Button, CollapseTransition } from 'element-ui';

export default {
  props: {
    relayPoint: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
    },
  },
  data() {
    return {
      isShowHoraire: false,
    };
  },
  components: {
    CarriersHoraire,
    SlideDownUp,
    ChevronDownIcon,
    Button,
    CollapseTransition,
  },
};
